import { ref, shallowRef } from 'vue'
import { pgMessage } from '../../message/index'
import { pgMessageBox } from '../../message-box/index'
import { post, compileData } from '../../../utils/index'

export function useSure({
  formData,
  submitUrl,
  submitParam,
  submitParamCompieFrom,
  forceSubmitText,
  successTip,
}) {
  const pgFormRef = ref(null)
  const submitLoading = ref(false)
  const submitErrors = shallowRef([])

  const submit = async (param) => {
    submitLoading.value = true
    const [res, error] = await post(submitUrl.value, param, { errorTip: null, successTip })
    submitLoading.value = false
    if (res) {
      return res
    } else if (
      error?.code === 400 &&
      error.errors?.length > 0 &&
      !error.errors.some((im) => im.level === 1)
    ) {
      submitErrors.value = error.errors ?? []
      const { onClose, type } = await new Promise((resolve) => {
        pgMessageBox({
          title: '提示',
          message: error.msg,
          cacelText: '取 消',
          confirmText: forceSubmitText.value ?? '强制提交',
          beforeClose(onClose, type) {
            resolve({ onClose, type })
          },
        })
      })
      if (type === 'confirm') {
        param.forceSubmit = true
        return submit(param)
      }
      onClose()
    } else {
      submitErrors.value = error.errors ?? []
      pgMessageBox({
        title: '提示',
        message: error.msg,
      })
    }
  }

  const getParamByFormData = () => {
    if (submitParamCompieFrom.value) {
      return compileData(submitParamCompieFrom.value, { data: formData.value })
    } else {
      return formData.value
    }
  }
  const sure = async () => {
    submitErrors.value = []
    const validateError = await pgFormRef.value.validate()
    if (validateError) {
      pgMessage.error('请完善必填信息')
    } else if (!submitUrl.value) {
      return formData.value
    } else {
      return submit(Object.assign({}, getParamByFormData(), submitParam.value))
    }
  }

  return {
    pgFormRef,
    submitLoading,
    sure,
    submitErrors,
  }
}
